const environmentConfigs = {
  local: {
    type: "local",
    appName: "cfsi",
    environmentDescription: "SI Development",
    getFileListUrl:
      "https://internal-dev1-apix.cvshealth.com/transparency/mrf/v1/fhmrffiles/buckets/{BucketName}",
    PROXY_URL:
      "https://transparency-mrf-reverseproxy.dev.cvshealth.com/v1/api/gcs/download",
    GUEST_TOKEN_API_URL:
      "https://internal-dev1-apix.cvshealth.com/guest/v1/token",
    b2cAuthUrl:
      "https://ngamrfnonprod.b2clogin.com/ngamrfnonprod.onmicrosoft.com/B2C_1A_signup_signin",
    b2cPassworkResetUrl:
      "https://ngamrfnonprod.b2clogin.com/ngamrfnonprod.onmicrosoft.com/B2C_1A_PasswordReset",
    b2cApiScope: "d2762289-acd1-4dad-b1c7-daa626fdc127",
    b2cLoginScope: "offline_access",
    b2cDomainName: "ngamrfnonprod.b2clogin.com",
    CVS_API_KEY: process.env.REACT_APP_CVS__DEV_API_KEY,
    prefix: "si_",
  },
  siDev: {
    type: "dev",
    appName: "cfsi",
    environmentDescription: "SI Development",
    getFileListUrl:
      "https://apix-dev1.cvshealth.com/transparency/mrf/v1/fhmrffiles/buckets/{BucketName}",
    PROXY_URL: "https://transparency-proxy.dev.aetna.com/v1/api/gcs/download",
    GUEST_TOKEN_API_URL: "https://apix-dev1.cvshealth.com/guest/v1/token",
    b2cAuthUrl:
      "https://ngamrfnonprod.b2clogin.com/ngamrfnonprod.onmicrosoft.com/B2C_1A_signup_signin",
    b2cPassworkResetUrl:
      "https://ngamrfnonprod.b2clogin.com/ngamrfnonprod.onmicrosoft.com/B2C_1A_PasswordReset",
    b2cApiScope: "d2762289-acd1-4dad-b1c7-daa626fdc127",
    b2cLoginScope: "offline_access",
    b2cDomainName: "ngamrfnonprod.b2clogin.com",
    CVS_API_KEY: process.env.REACT_APP_CVS_DEV_API_KEY,
    prefix: "si_",
  },
  siProd: {
    type: "prod",
    appName: "cfsi",
    environmentDescription: "SI Production",
    getFileListUrl:
      "https://apix.cvshealth.com/transparency/mrf/v1/fhmrffiles/buckets/{BucketName}",
    PROXY_URL: "https://transparency-proxy.aetna.com/v1/api/gcs/download/",
    GUEST_TOKEN_API_URL: "https://apix.cvshealth.com/guest/v1/token",
    b2cAuthUrl:
      "https://ngamrfprod.b2clogin.com/ngamrfprod.onmicrosoft.com/B2C_1A_signup_signin",
    b2cPassworkResetUrl:
      "https://ngamrfprod.b2clogin.com/ngamrfprod.onmicrosoft.com/B2C_1A_PasswordReset",
    b2cApiScope: "cccb1f26-5d96-4127-b125-15b286a1cfb8",
    b2cLoginScope: "offline_access",
    b2cDomainName: "ngamrfprod.b2clogin.com",
    CVS_API_KEY: process.env.REACT_APP_CVS_PROD_API_KEY,
    prefix: "si_",
  },
};

export const hostServer = () => {
  let envType;
  if (typeof window !== "undefined" && window.document) {
    try {
      const domain = document.domain || "";
      const hostname = window.location.hostname || "";
      const fullUrl = window.location.href || "";

      console.log("Environment detection - URL info:", {
        domain,
        hostname,
        fullUrl,
      });

      // Check for production environment
      if (
        hostname.includes("transparency-mrf-si-ui.prod.cvshealth.com") ||
        hostname.includes("mrf.aetna.com")
      ) {
        envType = "siProd";
        console.log("SI Production environment detected");
      }
      // Check for development environment
      else if (
        hostname.includes("transparency-mrf-si-ui.dev.cvshealth.com") ||
        hostname.includes("mrf-dev.aetna.com")
      ) {
        envType = "siDev";
        console.log("SI Development environment detected");
      }
      // Check for local environment
      else if (hostname.includes("localhost")) {
        envType = "local";
        console.log("Local environment detected");
      }

      console.log(`Final environment determination: ${envType}`);
    } catch (error) {
      console.error("Error in environment detection:", error);
      envType = "siDev"; // Changed to siDev for consistency
    }
  }

  return envType;
};

const appEnvironment = hostServer();

const envConfig =
  environmentConfigs[appEnvironment] || environmentConfigs["siDev"];

if (appEnvironment) {
  console.log(
    `App environment configured to: ${envConfig.environmentDescription}, detected host env: ${appEnvironment}`
  );
  console.log("Using API host:", envConfig.getFileListUrl);
  console.log("Using B2C auth URL:", envConfig.b2cAuthUrl);
}

export { appEnvironment };
export default envConfig;
